import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import '../styles/project-detail.css';
import { DEFAULT_PERSON_IMAGE } from '../constants';
import ProjectCard from './ProjectCard';
import Error from '../components/error-not-found';
import { useTranslation } from 'react-i18next';
import DataContext from '../contexts/DataContext';
import { BASE_URL } from '../constants';


const ProyectDetail = () => {
  const { id } = useParams();
  const [randomProjects, setRandomProjects] = useState([]);

  const { t, i18n } = useTranslation('project-detail');
  const { projects, people, isLoading } = React.useContext(DataContext);

  useEffect(() => {
    if (!isLoading) {
      const currentProject = projects.find(project => project.id === parseInt(id));
      if (currentProject) {
        const filteredProjects = projects.filter(project => project.researchArea === currentProject.researchArea && project.id !== parseInt(id));
        const randomProjects = filteredProjects.sort(() => Math.random() - 0.5).slice(0, 3);
        setRandomProjects(randomProjects);
        window.scrollTo(0, 0);
      }
    }
  }, [projects, isLoading, id]);


  const renderProjectCards = () => {
    return randomProjects.map(project => (
      <ProjectCard key={project.id} project={project} peopleInfo={false} verMas={false} />
    ));
  };

  const renderMembers = (members) => {
    
    const renderColumn = (columnMembers) => (
      <ul className="integrantes-column">
        {columnMembers.map((member, index) => {
          const person = people.find(p => p.username === member);
          if (!person) {
            console.warn(`No se encontró a la persona con el identificador "${member}" en los datos de las personas.`);
            return null;
          }

          const isUrl = person.image && (person.image.startsWith('http://') || person.image.startsWith('https://'));
          const imageSrc = person.image
            ? (isUrl ? person.image : `${BASE_URL}images/people/${person.image}`)
            : DEFAULT_PERSON_IMAGE;

          const imageElement = (
            <img
              src={imageSrc}
              className="rounded-circle mr-2 member"
              alt={`Integrante ${person.display_name}`}
              style={{ width: '50px', height: '50px' }}
            />
          )

          return person.webpage ? (
            <li key={index} className="integrante-item">
              <div className="integrante-info">
                <a href={person.webpage} target='_blank' rel="noopener noreferrer">
                  {imageElement}
                  <span>{person.display_name}</span>
                </a>
              </div>
            </li>
          ) : (
            <li key={index} className="integrante-item">
              <div className="integrante-info">
                {imageElement}
                <span>{person.display_name}</span>
              </div>
            </li>
          );
        })}
      </ul>
    );


    const columns = [];
    const numColumns = 2;
    const numIntegrantes = members.length;
    const integrantesPerColumn = Math.ceil(numIntegrantes / numColumns);

    for (let i = 0; i < numColumns; i++) {
      const startIndex = i * integrantesPerColumn;
      const endIndex = Math.min(startIndex + integrantesPerColumn, numIntegrantes);
      const columnMembers = members.slice(startIndex, endIndex);
      columns.push(renderColumn(columnMembers));
    }

    return (
      <div className="integrantes-container">
        {columns.map((column, index) => (
          <div key={index} className="integrantes-column-wrapper">
            {column}
          </div>
        ))}
      </div>
    );
  };

  const renderEventos = (eventos) => (
    <div className="eventos-grid w-100">
      {eventos.map((evento) => (
        <div key={evento.id} className="card event-card">
          {evento.foto && (
            <img
              src={`https://raw.githubusercontent.com/imagine-uniandes/web_data/main/img/events/${evento.foto}`}
              className="card-img-top"
              alt={`Imagen ${evento.nombre}`}
            />
          )}
          <div className="card-body">
            <h5 className="card-title">{evento.nombre}</h5>
            {evento.fecha && <p className="card-text">{evento.fecha}</p>}
            {evento.descripcion && <p className="card-text">{evento.descripcion}</p>}
          </div>
        </div>
      ))}
    </div>
  );

  if (isLoading) {
    return <div className="loading">{t('loading')}</div>;
  }

  const project = projects.find((project) => project.id === parseInt(id));

  if (!project) {
    return <Error />;
  }

  return (
    <div className="project-detail-container">
      <h1>{project.title}</h1>
      {project.image && (
        <img
          src={`${BASE_URL}images/projects/${project.image}`}
          alt={`Imagen ${project.title}`}
          style={{ height: '430px' }}
          className={"main-img"}
        />
      )}
      <p>{project.description}</p>
      {project.video && ( 
        <iframe className="project-detail-video" src={project.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      )}
      <p>{t('research-area')}: {project.area}</p>
      <h2 className="integrantes-heading">{t('members')}:</h2>
      {renderMembers(project.members)}
      {(project.link || project.repository) && (
        <>
          <h2 className="resources-heading">{t('link')}:</h2>
          <div className="project-resources">
            {project.link && (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="bi bi-box-arrow-up-right resource-icon"></i>
                <div className="resource-text">
                  <span className="resource-label">{t('link')}</span>
                  <span className="resource-domain">
                    {(() => { try { return new URL(project.link).hostname.replace('www.', ''); } catch { return project.link; } })()}
                  </span>
                </div>
              </a>
            )}
            {project.repository && (
              <a
                href={project.repository}
                target="_blank"
                rel="noopener noreferrer"
                className="resource-link"
              >
                <i className="bi bi-github resource-icon"></i>
                <div className="resource-text">
                  <span className="resource-label">{t('repository')}</span>
                  <span className="resource-domain">
                    {(() => { try { return new URL(project.repository).hostname.replace('www.', ''); } catch { return project.repository; } })()}
                  </span>
                </div>
              </a>
            )}
          </div>
        </>
      )}

      <h2>{t('related-projects')}:</h2>
      <div className="related-projects">
        {renderProjectCards()}
      </div>

      {project.eventos && project.eventos.length > 0 && (
        <>
          <h2 className="eventos">{t('events')}:</h2>
          <div className="events-container">
            {renderEventos(project.eventos)}
          </div>
        </>
      )}

    </div>
  );
};


export default ProyectDetail;